import { useEffect } from "react";
import SurveyCreatorWidget from "../components/SurveyCreatorWidget";
import SurveyComponent from "../components/SurveyComponent";

function App() {
  const params = new URLSearchParams(window.location.search);
  const mode = params.get("mode");
  const navType = params.get("nav_type"); // 'swipe' yoki 'button'

  useEffect(() => {
    const nextModeClass = mode === "creator" ? "creator-mode" : "embed-mode";
    const rootElement = document.documentElement;

    rootElement.classList.remove("creator-mode", "embed-mode");
    document.body.classList.remove("creator-mode", "embed-mode");

    rootElement.classList.add(nextModeClass);
    document.body.classList.add(nextModeClass);

    // Swipe (gesture) navigation needs a little extra bottom space for the
    // gesture bar; button navigation sits below the webview and pulls in a bit.
    document.body.classList.toggle("nav-swipe-mode", navType === "swipe");
    document.body.classList.toggle("nav-button-mode", navType === "button");

    return () => {
      rootElement.classList.remove(nextModeClass);
      document.body.classList.remove(nextModeClass, "nav-swipe-mode", "nav-button-mode");
    };
  }, [mode, navType]);

  if (mode === "creator") {
    return <SurveyCreatorWidget />;
  }

  return <SurveyComponent />;
}

export default App;
